import { LayoutDashboard, PlusCircle } from "lucide-react";

export const EMPLOYER_NAV = [
  { to: "/employer/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "enav-dashboard" },
  { to: "/employer/post-job", label: "Post a Job", icon: PlusCircle, testid: "enav-postjob" },
];
